import type { ColDef, ValueGetterParams } from 'ag-grid-community'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { ITemplate } from '~/types/template'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import TemplateStatusCellRenderer from '~/components/CellRenderers/TemplateStatusCellRenderer'
import TemplateTypeCellRenderer from '~/components/CellRenderers/TemplateTypeCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { badgeColDef, platformColDef, textColDef } from '~/utils/table'

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'version',
    headerName: 'Version',
    suppressHeaderMenuButton: true,
  }),
  {
    cellRenderer: TemplateTypeCellRenderer,
    field: 'type',
    headerName: 'Type',
    width: 130,
  },
  badgeColDef(BadgeCellRenderer, {
    field: 'capabilities',
    headerName: 'Capabilities',
    valueGetter: ({ data }: ValueGetterParams<ITemplate>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { capabilities } = data

      return {
        data: capabilities?.map((name) => ({ id: name, name })) || [],
        type: 'default',
      }
    },
  }),
  textColDef(TextCellRenderer, {
    field: 'navigationTargetOutputs',
    headerName: 'Nav. targets',
    suppressHeaderMenuButton: true,
  }),
  {
    cellRenderer: TemplateStatusCellRenderer,
    field: 'status',
    headerName: 'Status',
    maxWidth: 140,
  },
  platformColDef({
    field: 'deviceType',
  }),
]

export default columns
